import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
import type { SVGProps, SVGElementProps } from "../../types";

const Clipboard: SVGProps = (props: SVGElementProps) => <PathElement {...props} path={svgData.path.d} />;

export default Clipboard;
